import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TypPrzedmiotuUbezpieczenia} from '../../../../../../../../shared/model/przedmioty/typPrzedmiotuUbezpieczenia';

@Component({
  selector: 'app-podsumowanie-bez-uszkodzen',
  templateUrl: './podsumowanie-bez-uszkodzenia.component.html',
  styleUrls: ['./podsumowanie-bez-uszkodzenia.component.scss']
})
export class PodsumowanieBezUszkodzeniaComponent {

  language = window.navigator.language

  @Input()
  lokalizacja!: string

  @Input()
  zbiorUszkodzenPrzedmiotuId!: number

  @Input()
  zbiorUszkodzenId!: string

  @Input()
  opisLokalizacji!: string

  @Output()
  usunZbiorUszkodzenClick = new EventEmitter<{zbiorUszkodzenPrzedmiotowId: number, zbiorUszkodzenId: string}>()

  usunZbiorUszkodzen(event: {zbiorUszkodzenPrzedmiotowId: number, zbiorUszkodzenId: string}): void {
    this.usunZbiorUszkodzenClick.emit(event)
  }

  wybierzIkoneDlaPrzedmiotu(): string | undefined {
    return TypPrzedmiotuUbezpieczenia.pobierz(this.lokalizacja)?.ikona
  }
}
